import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DiscoSearchServiceClient } from "clients/disco-search-service-client";
import filterDisplayNameMap from "constants/filterDisplayNameMap";
import carouselTypes from "helpers/carousel-types";

const initialState = {
  pdpCarousels: {},
};

export const fetchCollectionCarousel = createAsyncThunk(
  "pdpCarousels/fetchCollection",
  async ({ collectionId, category }) => {
    try {
      const query = { curationId: [collectionId] };

      if (category) {
        query.category = [category];
      }

      // TODO: hardcoding lens for now until we figure out what we're doing with them
      const data = await DiscoSearchServiceClient.getInstance().curationSearch(query, 0, 40, "unlimited");

      const gridUrl = `/shop/${collectionId}/products`;
      const categoryDisplayText = filterDisplayNameMap.Category.values.find(cat => cat.id === category)?.value || null;
      const gridTitle = categoryDisplayText ? `New Arrivals: ${categoryDisplayText}` : "New Arrivals";

      return {
        title: gridTitle,
        subtitle: "View All",
        pixelName: "new_arrivals",
        type: carouselTypes.COLLECTION,
        products: data.items,
        url: gridUrl,
      };
    } catch (e) {
      console.error("Error fetching collection carousel:", e);
      return {};
    }
  }
);

export const fetchRecommendationCarousel = createAsyncThunk("pdpCarousels/fetchRecommendation", async query => {
  try {
    const data = await DiscoSearchServiceClient.getInstance().recommendationSearch(query, 0, 40);

    const { products, title } = data.recommendations[0];
    const { category, useCaseEvent } = query;
    const gridUrl = `/products?category=${category.toLowerCase()}&useCaseEvent=${useCaseEvent[0].toLowerCase()}`;
    return {
      title: "More " + title + " like this",
      subtitle: "View All",
      pixelName: "recommendations",
      type: carouselTypes.RECOMMENDATION,
      products: products,
      url: gridUrl,
    };
  } catch (e) {
    console.error("Error fetching recommentation carousel:", e);
    return {};
  }
});

export const pdpCarouselsSlice = createSlice({
  name: "pdpCarousels",
  initialState,
  extraReducers: builder => {
    builder.addCase(fetchCollectionCarousel.fulfilled, (state, action) => {
      state.pdpCarousels = state.pdpCarousels ||= {}; // initial state doesn't seem to work so being defensive :/
      state.pdpCarousels.collection = action.payload;
    });
    builder.addCase(fetchRecommendationCarousel.fulfilled, (state, action) => {
      state.pdpCarousels = state.pdpCarousels ||= {}; // initial state doesn't seem to work so being defensive :/
      state.pdpCarousels.recommendation = action.payload;
    });
  },
});

/**
 * This value isn't used anywhere.
 * It's only defined because ReduxApp expects reducers to have a "types" property
 */
export const types = ["pdpCarousels/fetchCollection/fulfilled", "pdpCarousels/fetchRecommendation/fulfilled"];

export default {
  types: types,
  fn: pdpCarouselsSlice.reducer,
};
